import axios from 'axios'
import {
  FETCH_ABO_INFO,
  FETCH_SURVEY_INFO,
  FETCH_DATAS,
  FETCH_DOWNLOAD_FILE,
  INIT_DATAS,
  CLEAR_RESPONSE_DATA,
  OPEN_POPUP,
  CLOSE_POPUP,
  VALIDATE_DATA,
  SUBMIT_SURVEY,
  FIRST_SUBMIT,
  SAVE_SUBMIT,
  SET_INIT_COMPLETED,
  SET_ABO_UID,
  SET_PIN_LEVEL,
  SET_BASIC_DATA,
  SET_RESPONSE_DATAS,
  SET_ORIGINALS,
  SET_RESPONSES_FOR_DELETE,
  SET_CONSENTS,
  SET_QUESTIONS,
  SET_COMMONS,
  SET_ACTIVITY_REMAIN_NUM,
  SET_MODE,
  SET_POPUP_CONTENT,
  SET_SCHEDULE,
  TOGGLE_POPUP,
  TOGGLE_INTEREST_FEE_POPUP,
  TOGGLE_ACTIVITY_POPUP,
  SET_LOADING,
  UPDATE_ACTIVITY_REMAIN_NUM,
  ADD_NEW_FAMILY,
  REMOVE_FAMILY,
  CLEAR_COMMON_DATA,
  SELECT_CHOICE_DATA,
  SELECT_SCHEDULE_DATA,
  SET_ATTENDANCE,
  SET_FILES_FOR_DELETE,
  SET_NAME,
  SET_CONSENT_YN,
  SET_QUESTION_ANSWER,
  SET_CHOICE_QUESTION,
  SET_FAMILY_ATTENDANCE_YN,
  SET_PAYMENT_INFO,
  SET_COMMON_DATA,
  SET_ORIGINAL_COMMON_DATA,
  MAIN_RESPONSES,
  FAMILY_RESPONSES,
  ATTENDING_LIST,
  EXIST_ATTENDANT,
  SPOUSE_ATTENDANTS,
  MEMBER_ATTENDANTS,
  FAMILY_ATTENDANTS,
  COMMON_QUESTIONS,
  INFO_QUESTIONS,
  ACTIVITY_QUESTIONS,
  SCHEDULE_QUESTIONS,
  REQUIRED_CONSENTS,
  OPTIONAL_CONSENTS,
  GET_DATA_IDX_BY_TYPE,
  GET_RESPONSE_DATA,
  GET_DEFAULT_CONSENTS_RESPONSE,
  GET_DEFAULT_QUESTIONS_RESPONSE,
  GET_DEFAULT_ACTIVITY_RESPONSE,
  GET_ORIGINAL_IDX_BY_SEQ,
  GET_ORIGINAL_ATTENT_YN,
  GET_NEW_FAMILY,
  GET_FAMILY_INDEX,
  IS_FAMILY_NEED_PAYMENT,
  NUMBER_OF_ATTENDEES,
  INFO_AVAILABLE,
  ACTIVITY_AVAILABLE,
  NEED_FAMILY_RELATION_DOCUMENT,
  NEED_FAMILY_DOCUMENT,
  FAMILY_ATTENDANCE_YN,
  GET_CODE_COUNTRY,
  SET_CODES,
  FETCH_CODES,
  GET_CODE_ABO_TYPE,
  GET_CODE_GENDER,
  GET_CODE_MINOR_AGE_YMD,
  GET_QUESTIONS,
  GET_CODE_TODAY,
  GET_CODE_PASSPORT_DATE,
  GET_NAME_OF_INDEX,
  SET_HINT, 
} from '../actions/survey'
import {
  getErrorMsg, questionComparator, responseComparator, getMessage, getFullTextByType
} from '@/utils/survey'
import { deleteFilesFromS3 } from '@/utils/fileUpload'

const state = {
  popup: {
    open: false,
    headerText: '',
    component: null,
    props: null,
    showHeader: true,
    showConfirmBtn: false,
  },
  popup_interestfee: false,
  popup_activity: false,
  loading: false,
  isInitCompleted: false,
  abo_uid: '',
  mode: 'W', // 처음 작성: 'W', 수정: 'E'
  info_available_yn: '',
  activity_available_yn: '',
  s_code: '',
  wave_number: 0,
  title: '',
  pin_level: '', // 암웨이 핀 등급
  responses: null, // 작성자 응답 데이터
  originals: null, // 수정시 기존 응답 데이터
  responsesForDelete: [],
  consents: null, // 약관 메타데이터
  questions: null, // 설문 문항 메타데이터
  commonData: null, // 공통 문항 데이터
  originalCommonData: null,
  filesForDelete: [],
  golf: [['Q019', 'E025'], ['Q020', 'E036'], ['Q021', 'E047']],
  spa: [['Q019', 'E026'], ['Q020', 'E037'], ['Q021', 'E048']],
  codes: {
    country: [] // 국가코드 
  },  // 공통 코드 자료 
  scheduleData: null, // 일정정보 
  hint: null, // 도움말 표시 여부 
};

const getters = {
  [MAIN_RESPONSES](state) { // 단독/공동 사업자 및 배우자
    return state.responses ? state.responses.filter(response => response.type !== 'F') : [];
  },
  [FAMILY_RESPONSES](state) { // 동반 가족
    return state.responses ? state.responses.filter(response => response.type === 'F') : [];
  },
  [ATTENDING_LIST](state) { // 전체 인원 중 참석자
    return state.responses ? state.responses.filter(response => response.attendance_yn === 'Y') : [];
  },
  [EXIST_ATTENDANT](state, getters) { // 참석자 존재 여부
    return getters[ATTENDING_LIST].length > 0;
  },
  [SPOUSE_ATTENDANTS](state, getters) { // 참석자 중 배우자
    return getters[ATTENDING_LIST].filter(response => response.type === 'S');
  },
  [MEMBER_ATTENDANTS](state, getters) { // 참석자 중 사업자
    return getters[ATTENDING_LIST].filter(response => ['E', 'P'].includes(response.type));
  },
  [FAMILY_ATTENDANTS](state, getters) { // 참석자 중 동반가족
    return getters[ATTENDING_LIST].filter(response => response.type === 'F');
  },
  [COMMON_QUESTIONS](state) {
    return state.questions ? state.questions['C'] || {} : {};
  },
  [INFO_QUESTIONS](state) {
    return state.questions ? state.questions['I'] || {} : {};
  },
  [ACTIVITY_QUESTIONS](state) {
    return state.questions ? state.questions['Q'] || {} : {};
  },
  [SCHEDULE_QUESTIONS](state) {
    return state.questions ? state.questions['R'] || {} : {};
  },
  [REQUIRED_CONSENTS](state) {
    return Object.keys(state.consents)
      .filter(c_code => state.consents[c_code].required === 'TRUE')
      .map(c_code => state.consents[c_code]);
  },
  [OPTIONAL_CONSENTS](state) {
    return Object.keys(state.consents)
    .filter(c_code => state.consents[c_code].required === 'FALSE')
    .map(c_code => state.consents[c_code]);
  },
  [INFO_AVAILABLE](state) {
    return state.info_available_yn === 'Y';
  },
  [ACTIVITY_AVAILABLE](state) {
    return state.activity_available_yn === 'Y';
  },
  // **** 가족관계증명서 필요 여부 ****
  [NEED_FAMILY_RELATION_DOCUMENT](state, getters) {
    const attendingList = getters[ATTENDING_LIST];
    if(attendingList.some(attendant => attendant.type === 'E')) { // 단독 사업자 존재 시
      return attendingList.length > 1; // 단독 사업자 이외의 다른 참석자가 있으면 필요
    } else {
      // 공동사업자의 경우
      // 공동사업자 모두 참석하거나, 공동사업자 한명과 동반가족이 참가하는 경우 필요
      const parties = attendingList.filter(attendant => attendant.type === 'P');
      if (state.s_code == 'Sydney') {
        return false;
      }

      return parties.length === 2 || (parties.length > 0 && getters[FAMILY_ATTENDANTS].length > 0);
    }
  },
  // **** 객실 추가 신청서 필요 여부 ****
  [NEED_FAMILY_DOCUMENT](state, getters) {
    return getters[FAMILY_ATTENDANTS].length > 0;
  },
  [FAMILY_ATTENDANCE_YN](state, getters) {
    if(getters[FAMILY_RESPONSES].length === 1) {
      return getters[FAMILY_RESPONSES][0].attendance_yn;
    } else {
      return getters[FAMILY_RESPONSES].every(family => family.attendance_yn === 'Y') ? 'Y' : 'N';
    }
  },
  [GET_DATA_IDX_BY_TYPE](state) {
    return (type, type_seq) => state.responses.findIndex(response => {
      if(response.type_seq) { // 타입 시퀀스도 있다면 타입 시퀀스도 포함하여 찾기
        return response.type === type && response.type_seq === type_seq;
      } else {
        return response.type === type;
      }
    });
  },
  /**
   * 응답자 별 약관, 응답 데이터 가져오는 함수
   * - 응답 데이터는 필수 응답이면 데이터 체크를 하고, 선택 응답인 경우에는 모두 가져온다.
   * @return {Array} [약관 응답 데이터 배열, 문항 응답 데이터 배열]
   */
  [GET_RESPONSE_DATA](state, getters) {
    return (response) => {
      const infoAvailable = getters[INFO_AVAILABLE];
      const activityAvailable = getters[ACTIVITY_AVAILABLE];

      // 반환될 데이터
      let consents = [];
      let datas = [];

      if(infoAvailable) {
        // 약관 동의 데이터 가공
        const required = response.consents.hasOwnProperty('required') ? 
          getters[REQUIRED_CONSENTS].map(consent => ({ c_code: consent.c_code, agree_yn: response.consents.required })) : [];
        const optional = response.consents.hasOwnProperty('optional') ?
          getters[OPTIONAL_CONSENTS].map(consent => ({ c_code: consent.c_code, agree_yn: response.consents.optional })) : [];

        consents = [...required, ...optional];

        // 사용자 정보 데이터 가공
        const infoQuestions = getters[INFO_QUESTIONS];
        Object.keys(response.questions)
          // 사용자 정보 문항만 필터링
          .filter(sq_code => Object.keys(infoQuestions).includes(sq_code))
          .forEach(sq_code => {
            const { type } = infoQuestions[sq_code];
            // 문항 타입 별 처리
            switch (type) {
              case 'B': // 주관식
                const rawData = response.questions[sq_code].raw_data;
                rawData && datas.push({ ...response.questions[sq_code] });
                break;

              case 'F': // 파일 데이터
                const { path, original_name } = response.questions[sq_code];
                (path && original_name) && datas.push({ ...response.questions[sq_code] });
                break;
            }
          });
      }

      if(activityAvailable) {
        // 액티비티 데이터 가공
        const activityQuestions = getters[ACTIVITY_QUESTIONS];
        Object.keys(response.questions)
          .filter(sq_code => Object.keys(activityQuestions).includes(sq_code))
          .forEach(sq_code => {
            const choices = response.questions[sq_code];
            choices.forEach(choice => {
              const { srd_seq, se_code, se_data, checked } = choice;
              // 일반 액티비티 선택 안함 선택
              if(!se_code) {
                se_code === '' && datas.push({ ...choice });
              }
              else {
                // 일반 액티비티
                datas.push({ ...choice });
              }
            });
          });

          // 일정 데이터 가공
        const scheduleQuestions = getters[SCHEDULE_QUESTIONS];
        Object.keys(response.questions)
          .filter(sq_code => Object.keys(scheduleQuestions).includes(sq_code))
          .forEach(sq_code => {
            const choices = response.questions[sq_code];
            choices.forEach(choice => {
              const { srd_seq, se_code, se_data, checked } = choice;
              // 일반 액티비티 선택 안함 선택
              if(!se_code) {
                se_code === '' && datas.push({ ...choice });
              } else {
                // 일반 액티비티
                datas.push({ ...choice });
              }
            });
          });
      }

      return [consents, datas];
    }
  },
  // 초기 약관 데이터 세팅용
  [GET_DEFAULT_CONSENTS_RESPONSE](state, getters) {
    const consents = {};
    if(getters[REQUIRED_CONSENTS].length > 0) {
      consents.required = null;
    }
    if(getters[OPTIONAL_CONSENTS].length > 0) {
      consents.optional = null;
    }
    return () => ({ ...consents });
  },
  // 초기 문항 데이터 세팅용
  [GET_DEFAULT_QUESTIONS_RESPONSE](state, getters) {
    return (type) => {
      const metadata1 = getters[INFO_QUESTIONS];
      const metadata2 = getters[ACTIVITY_AVAILABLE] ? getters[ACTIVITY_QUESTIONS] : {};
      const metadata3 = getters[SCHEDULE_QUESTIONS];
      // 공통 데이터 제외한 문항 메타데이터
      const metadata = { ...metadata1, ...metadata2, ...metadata3};
      const questions = {};
      Object.keys(metadata)
        .filter(sq_code => {
          const res_type = metadata[sq_code].res_type;
          return !res_type || res_type.includes(type);
        }).forEach(sq_code => {
          const defaultData = {
            sq_code,       
            se_code: null,      
            se_data: null,      
            raw_data: null,     
            path: null,         
            original_name: null,
            remarks: null,
            hasError: true
          };

          const { type: questionType, examples } = metadata[sq_code];
          // 객관식과 나머지 문항과 구분
          if(questionType === 'A') {
            questions[sq_code] = [defaultData];
          } else {
            questions[sq_code] = defaultData;
          }
        });
      return questions;
    };
  },
  [GET_DEFAULT_ACTIVITY_RESPONSE](state, getters) {
    return (sq_code, type) => {
      const metadata = getters[ACTIVITY_QUESTIONS];
      const activityMetadata = metadata[sq_code];
      const defaultData = {
        sq_code,       
        se_code: null,      
        se_data: null,      
        raw_data: null,     
        path: null,         
        original_name: null,
        remarks: null,
        hasError: false
      };

      
      return [defaultData];
    };
  },
  [GET_ORIGINAL_ATTENT_YN] (state) { 
    return state.originals ? state.originals.filter(attendant => attendant.attendance_yn === 'Y').length > 0 : false;
  }, 
  // 기존 응답 데이터의 인덱스 조회
  [GET_ORIGINAL_IDX_BY_SEQ](state) {
    return (sr_seq) => state.originals ? state.originals.findIndex(original => original.sr_seq === sr_seq) : -1;
  },
  [GET_NEW_FAMILY](state, getters) {
    return (attendance_yn) => {
      const type = 'F';
      const familyResponses = getters[FAMILY_RESPONSES];
      const type_seq = familyResponses.length === 0 ? 1 : Math.max(...familyResponses.map(family => family.type_seq)) + 1;
      const consents = getters[GET_DEFAULT_CONSENTS_RESPONSE]();
      const questions = getters[GET_DEFAULT_QUESTIONS_RESPONSE](type);
      return {
        abo_uid: state.abo_uid,
        attendance_yn,
        name: '',
        s_code: state.s_code,
        wave_number: state.wave_number,
        type,
        type_seq,
        consents,
        questions,
        paymentInfo: null
      };
    }
  },
  [GET_FAMILY_INDEX](state, getters) {
    return (type_seq) => getters[FAMILY_ATTENDANTS].findIndex(family => family.type_seq === type_seq);
  },
  [IS_FAMILY_NEED_PAYMENT](state, getters) {
    return (type_seq) => {
      const index = getters[GET_FAMILY_INDEX](type_seq);
      const attendingList = getters[ATTENDING_LIST];
      if(attendingList.length > 3) { // 참석인원이 4명 이상일 때 요금부과
        if(getters[MEMBER_ATTENDANTS].length === 2) { // 공동사업자 1,2 참석일때는
          return index >= 1; // 두번째 동반가족부터 요금부과
        } else if(getters[MEMBER_ATTENDANTS].length === 1) { // 공동사업자 한명 혹은 단독사업자의 경우에는
          if(getters[SPOUSE_ATTENDANTS].length === 1) { // 배우자가 참석한다면
            return index >= 1; // 두번째 동반가족부터 요금부과
          } else { // 배우자가 없다면
            return index >= 2; // 세번째 동반가족부터 요금부과
          }
        }
      } else { // 참석인원이 3명 이하는 요금부과 x
        return false;
      }
    }
  },
  // vip 액티비티 별 총 참석 가능 인원
  [NUMBER_OF_ATTENDEES](state) {
    const pinLevel = Number(state.pin_level || '');
    // pin level에 따른 참석 가능 인원
    switch (true) {
      case pinLevel >= 420: // FC
        return 6;
      case pinLevel >= 390: // EDC
        return 4;
      case pinLevel >= 380: // DIA
        return 2;
      default: // 일반 ABO
        return 0;
    }
  },
  [GET_CODE_COUNTRY](state) { 
    return state.codes.country || []
  },
  [GET_CODE_ABO_TYPE](state) {
    return state.codes.SR_TYPE
  },
  [GET_CODE_GENDER](state) {
    return state.codes.SR_GENDER
  },
  [GET_CODE_MINOR_AGE_YMD](state) { 
    return state.codes.MINOR_AGE
  },
  [GET_QUESTIONS](state){
    return state.responses
  },
  [GET_CODE_TODAY](state){ 
    return state.codes.TODAY
  },
  [GET_CODE_PASSPORT_DATE](state){ 
    return state.codes.PASSPORT_DATE
  },
  [GET_NAME_OF_INDEX](state) { 
    return state.responses.map(response => response.name)
  }
};

const mutations = {
  [SET_INIT_COMPLETED](state, isCompleted) {
    state.isInitCompleted = isCompleted;
  },
  [SET_ABO_UID](state, abo_uid) {
    state.abo_uid = abo_uid;
  },
  [SET_PIN_LEVEL](state, pin_level) {
    state.pin_level = pin_level;
  },
  [SET_BASIC_DATA](state, metadata) {
    state.s_code = metadata.s_code;
    state.wave_number = metadata.wave_number;
    state.title = metadata.title;
    state.info_available_yn = metadata.info_available_yn;
    state.activity_available_yn = metadata.activity_available_yn;
  },
  [SET_RESPONSE_DATAS](state, responses) {
    state.responses = responses;
  },
  [SET_ORIGINALS](state, originals) {
    state.originals = originals;
  },
  [SET_RESPONSES_FOR_DELETE](state, response) {
    state.responsesForDelete = [...state.responsesForDelete, response];
  },
  [SET_CONSENTS](state, consents) {
    state.consents = consents;
  },
  [SET_QUESTIONS](state, questions) {
    state.questions = questions;
  },
  [SET_COMMONS](state, commonData) {
    state.commonData = commonData;
  },
  [SET_SCHEDULE](state, scheduleData) {
    state.scheduleData = scheduleData;
  },
  [SET_ACTIVITY_REMAIN_NUM](state, { sq_code, se_code, remain_num }) {
    state.questions['Q'][sq_code].examples[se_code].remain_num = remain_num;
  },
  [SET_MODE](state, mode) {
    state.mode = mode;
  },
  [SET_POPUP_CONTENT](state, { headerText, component, props, showHeader = true, showConfirmBtn = false }) {
    state.popup.headerText = headerText;
    state.popup.component = component;
    state.popup.props = props;
    state.popup.showHeader = showHeader;
    state.popup.showConfirmBtn = showConfirmBtn;
  },
  [TOGGLE_POPUP](state, open) {
    state.popup.open = open;
  },
  [TOGGLE_INTEREST_FEE_POPUP](state, toggle) {
    state.popup_interestfee = toggle;
  },
  [TOGGLE_ACTIVITY_POPUP](state, toggle) {
    state.popup_activity = toggle;
  },
  [SET_LOADING](state, loading) {
    state.loading = loading;
  },
  [SET_ATTENDANCE](state, { idx, attendance_yn }) {
    state.responses[idx].attendance_yn = attendance_yn;
  },
  [SET_FILES_FOR_DELETE](state, fileKey) {
    state.filesForDelete = [...state.filesForDelete, fileKey]
  },
  [SET_NAME](state, { idx, name }) {
    state.responses[idx].name = name;
  },
  [SET_CONSENT_YN](state, { idx, key, yn }) {
    state.responses[idx].consents[key] = yn;
  },
  [SET_QUESTION_ANSWER](state, { idx, sq_code, ...data }) {
    const copy = { ...state.responses[idx].questions[sq_code] };
    state.responses[idx].questions[sq_code] = { ...copy, ...data };
  },
  [SET_CHOICE_QUESTION](state, { idx, sq_code, choices }) {
    state.responses[idx].questions[sq_code] = choices;
  },
  [SET_FAMILY_ATTENDANCE_YN](state, yn) {
    state.responses
      .filter(response => response.type === 'F')
      .forEach(response => response.attendance_yn = yn);
  },
  [SET_PAYMENT_INFO](state, { idx, paymentInfo }) {
    state.responses[idx].paymentInfo = { ...state.responses[idx].paymentInfo, ...paymentInfo };
  },
  [SET_COMMON_DATA](state, { sq_code, ...data }) {
    const copy = { ...state.commonData[sq_code] };
    state.commonData[sq_code] = { ...copy, ...data };
  },
  [SET_ORIGINAL_COMMON_DATA](state, commonData) {
    state.originalCommonData = commonData;
  },
  [SET_CODES](state, codeData) {
    state.codes = codeData;
  },
  [SET_HINT](state, isHint) {
    state.hint = isHint
  }
};

const actions = {
  async [FETCH_DOWNLOAD_FILE] ({dispatch, commit}, {s_code, wave_number, sr_seq, sq_code, abo_uid}) { 
    // api parameter 설정
    const _params = { 
      s_code: s_code, 
      wave_number: wave_number, 
      sr_seq: sr_seq, 
      sq_code:sq_code,
      abo_uid: abo_uid,
      env: process.env.NODE_ENV
    }
    
    const { data } = await axios.get(`${process.env.AWS_GATEWAY_URL_V2}/survey/attachment/download`
    , {params: _params}
    , {withCredentials: process.env.REQUEST_WITH_CREDENTIALS});

    if(data.status !== 200) {
      throw new Error(getErrorMsg(data.status, data.message));
    }
    return data.files;
  }, 

  async [FETCH_CODES]({ dispatch, commit }) {
    // country code 조회 
    const { data } = await axios.post(`${process.env.AWS_GATEWAY_URL_V2}/survey/code`);
    if(data.status !== 200) {
      throw new Error(getErrorMsg(data.status, data.message));
    }
    commit(SET_CODES, data.codes);
  },

  /**
   * 설문 페이지 로드를 위한 데이터 조회 및 세팅
   * @param {Object} payload s_code, wave_number, abo_uid 정보
   */
  async [FETCH_DATAS]({ dispatch }, payload) {
    await dispatch(FETCH_CODES);
    const { s_code, wave_number, abo_uid } = payload;
    // abo 정보 조회
    const { customers, levelCode } = await dispatch(FETCH_ABO_INFO, abo_uid);
    const pinLevel = levelCode.substring(levelCode.lastIndexOf('_') + 1);
    // survey 정보 조회
    const surveyInfo = await dispatch(FETCH_SURVEY_INFO, {
      s_code, wave_number,
      customers: customers.sort((a, b) => b.isPrimary - a.isPrimary),
      pinLevel
    });

    const schedule = {}

    dispatch(INIT_DATAS, { ...surveyInfo, pinLevel, schedule });
  },

  /**
   * 설문 코드, 설문 회차, ABO Uid로 설문 정보 및 응답 데이터 조회
   * @param {Object} payload s_code, wave_number, abo_uid 정보
   */
  async [FETCH_SURVEY_INFO](context, payload) {
    const { data } = await axios.post(`${process.env.AWS_GATEWAY_URL_V2}/survey/info`, payload);
    if(data.status !== 200) {
      throw new Error(getErrorMsg(data.status, data.message));
    }
    return data;
  },

  /**
   * ABO 정보를 조회
   * @param {string} aboUid
   */
  async [FETCH_ABO_INFO](context, abo_uid) {
    const { data } = await axios.post(`${process.env.AWS_GATEWAY_URL_V2}/survey/aboinfo`, { abo_uid });
    if(data.status !== 200) {
      throw new Error(getErrorMsg(data.status, data.message));
    }
    return data;
  },

  /**
   * 조회한 설문 데이터를 바탕으로 데이터 세팅
   */
  [INIT_DATAS]({ state, commit, getters }, { pinLevel, metadata, responses, isInitial, commons, schedule }) {
    // 1. 페이지 모드 및 ABO 등급 정보 세팅
    commit(SET_MODE, isInitial ? 'W' : 'E');
    commit(SET_PIN_LEVEL, pinLevel);
    // 2. 서베이 마스터 데이터 세팅
    commit(SET_BASIC_DATA, metadata);

    // 3. 약관 데이터
    commit(SET_CONSENTS, metadata.consents);

    // 4. 설문 문항 데이터
    const questionCodes = Object.keys(metadata.questions);
    const questions = {};
    questionCodes.forEach(sq_code => {
      const area = metadata.questions[sq_code].area;
      // console.log(">>>> 설문 문항 설정 : ", sq_code, area)
      if(!questions[area]) questions[area] = {};
      questions[area][sq_code] = metadata.questions[sq_code];
    });
    commit(SET_QUESTIONS, questions);

    // 5. 서베이 기존 응답 데이터 세팅
    if(!isInitial) {
      const originalResponses = responses
        // .filter(response => !!response.attendance_yn) // 동반가족 기본 세팅 데이터 제거
        .map(response => ({
          ...response,
          consents: { ...response.consents },
          questions: { ...response.questions }
        }))
        .sort(responseComparator);
      commit(SET_ORIGINALS, originalResponses);
    }

    // 6. 서베이 응답 데이터 세팅
    let response_datas;
    if(isInitial) {
      response_datas = responses.map(response => ({
        ...response,
        consents: getters[GET_DEFAULT_CONSENTS_RESPONSE](),
        questions: getters[GET_DEFAULT_QUESTIONS_RESPONSE](response.type)
      }));
    } else {
      // 이전 응답에 동반가족이 없었던 경우에 초기 동반가족 데이터 세팅
      if(!responses.some(response => response.type === 'F')) {
        const initialFamily = getters[GET_NEW_FAMILY]('N');
        responses.push(initialFamily);
      }
      
      const question_metadata = { ...getters[INFO_QUESTIONS], ...getters[ACTIVITY_QUESTIONS], ...getters[SCHEDULE_QUESTIONS] };
      response_datas = responses.map(response => {
        // 6-1. 기존 약관 동의 응답 데이터 세팅
        let consents = {};
        let questions = {};

        // 기존 '불참' 선택한 설문자는 약관, 문항 데이터 따로 세팅
        if(!response.attendance_yn || response.attendance_yn === 'N') {
          consents = getters[GET_DEFAULT_CONSENTS_RESPONSE]();
          questions = getters[GET_DEFAULT_QUESTIONS_RESPONSE](response.type);
        } else {
          // 기존 '참가' 선택한 설문자 약관 데이터 세팅
          const consentKeys = Object.keys(response.consents);
          const requiredConsents = consentKeys.filter(c_code => metadata.consents[c_code].required === 'TRUE');
          const optionalConsents = consentKeys.filter(c_code => metadata.consents[c_code].required === 'FALSE');
  
          // 필수 동의 약관
          if(requiredConsents.length > 0) {
            consents.required = requiredConsents.every(c_code => response.consents[c_code].agree_yn === 'Y') ? 'Y' : 'N';
          }
          // 선택 동의 약관
          if(optionalConsents.length > 0) {
            consents.optional = optionalConsents.every(c_code => response.consents[c_code].agree_yn === 'Y') ? 'Y' : 'N';
          }

          // 6-2. 서베이 질문 별 데이터
          Object.keys(question_metadata).filter(sq_code => {
            const { res_type } = question_metadata[sq_code];
            return !res_type || res_type.includes(response.type);
          }).forEach(sq_code => {
            const { type, area } = question_metadata[sq_code];
            const choices = response.questions[sq_code];

            const defaultData = {
              sq_code,       
              se_code: null,      
              se_data: null,      
              raw_data: null,     
              path: null,         
              original_name: null,
              remarks: null,
            }
            // 액티비티 question
            if(area === 'Q' || area === 'R') {
              if(!choices) {
                // 액티비티 응답 자체가 없는 경우
                questions[sq_code] = getters[GET_DEFAULT_ACTIVITY_RESPONSE](sq_code, response.type);
              } else {
                // 액티비티 응답 있을때(일반 액티비티와 vip액티비티 중 없는 데이터 있을 수 있다.)
                const { examples } = question_metadata[sq_code];
                
                // 일반 example 응답이 없으면 기본값 추가
                const normalExamples = Object.keys(examples).filter(se_code => !examples[se_code].pin);
                const normalChoice = choices.find(choice => choice.se_code === '' || normalExamples.includes(choice.se_code));
                if(normalChoice) {
                  questions[sq_code] = [normalChoice];
                } else {
                  questions[sq_code] = [defaultData];
                }
              }
            // 일반 question
            } else {
              if(!choices) {
                questions[sq_code] = type === 'A' ? [defaultData] : defaultData;
              } else {
                questions[sq_code] = choices;
              }
            }
          });

          // 설문 문항에 hasError 추가
          Object.keys(questions).forEach(sq_code => {
            const question = questions[sq_code];
            if(question_metadata[sq_code].type === 'A') {
              question.forEach(choice => choice.hasError = false);
            } else {
              question.hasError = false;
            }
          });
        }

        return {
          ...response,
          consents,
          questions
        };
      });
    }
    commit(SET_RESPONSE_DATAS, response_datas.sort(responseComparator));

    // 7. 동반가족 참석 여부 세팅
    const family_attendance = getters[FAMILY_RESPONSES];
    if(family_attendance.length === 1) {
      commit(SET_FAMILY_ATTENDANCE_YN, family_attendance[0].attendance_yn);
    } else if(family_attendance > 1) {
      commit(SET_FAMILY_ATTENDANCE_YN, family_attendance.every(family => family.attendance_yn === 'Y') ? 'Y' : 'N');
    }

    // 8. 서베이 공통 응답 기존 데이터 세팅
    commit(SET_ORIGINAL_COMMON_DATA, commons);

    // 9. 서베이 공통 응답 데이터 세팅
    const commonQuestions = getters[COMMON_QUESTIONS];
    const commonData = {};
    Object.keys(commonQuestions).forEach(sq_code => {
      if(commons[sq_code]) { // 기존 commons 데이터가 있을 때
        commonData[sq_code] = commons[sq_code];
      } else { // 기존 commons 데이터가 없는 경우
        const { type } = commonQuestions[sq_code];
        const initialData = { s_code: state.s_code, wave_number: state.wave_number, abo_uid: state.abo_uid };
        // 공통 응답 데이터 타입별 처리
        if(type === 'F') {
          initialData.reference = `file_${sq_code}`;
          initialData.path = null;
          initialData.original_name = null;
        }

        commonData[sq_code] = initialData;
      }
    });
    commit(SET_COMMONS, commonData);

    // 10. 스케줄 공통 응답 데이터 세팅
    const scheduleQuestions = getters[SCHEDULE_QUESTIONS];
    const scheduleData = {};
    
    Object.keys(scheduleQuestions).forEach(sq_code => {
      if(schedule[sq_code]) { // 기존 commons 데이터가 있을 때
        scheduleData[sq_code] = schedule[sq_code];
      } else { // 기존 commons 데이터가 없는 경우
        const initialData = { s_code: state.s_code, wave_number: state.wave_number, abo_uid: state.abo_uid, se_code: '' };        
        scheduleData[sq_code] = initialData;
      }
    });
   
    commit(SET_SCHEDULE, scheduleData);
    

    // --- 데이터 세팅 완료 ---
    commit(SET_INIT_COMPLETED, true);
  },
  /**
   * 불참 선택 시 입력했던 응답 데이터 삭제
   */
  [CLEAR_RESPONSE_DATA]({ state, getters, commit }, idx) {
    commit(SET_LOADING, true);

    const response = state.responses[idx];
    // 약관 동의 응답 초기화
    Object.keys(response.consents).forEach(key => {
      commit(SET_CONSENT_YN, { idx, key, yn: null });
    });

    // 설문 문항 응답 초기화
    Object.keys(response.questions).forEach(sq_code => {
      const question = getters[INFO_QUESTIONS][sq_code] || getters[ACTIVITY_QUESTIONS][sq_code] || getters[SCHEDULE_QUESTIONS][sq_code] || {};
      if(question.type === 'F') {
        const { original_name, path } = response.questions[sq_code];
        if(original_name && path) {
          commit(SET_FILES_FOR_DELETE, `${path}/${original_name}`);
        }
      }

      const defaultData = {
        se_code: null,
        se_data: null,
        raw_data: null,
        path: null,
        original_name: null,
        remarks: null,
        hasError: true,
      };

      if(question.type === 'A') {
        commit(SET_CHOICE_QUESTION, { idx, sq_code, choices: [defaultData] });        
      } else {
        commit(SET_QUESTION_ANSWER, { idx, sq_code, ...defaultData });
      }
    });

    commit(SET_LOADING, false);
  },
  [OPEN_POPUP]({ commit }, { headerText, component, props = null, showHeader = true, showConfirmBtn = false, disabled = false }) {
    commit(SET_POPUP_CONTENT, { headerText, component, props, showHeader, showConfirmBtn, disabled });
    commit(TOGGLE_POPUP, true);
  },
  [CLOSE_POPUP]({ commit }) {
    commit(SET_POPUP_CONTENT, { headerText: '', component: null, props: null });
    commit(TOGGLE_POPUP, false);
  },
  [VALIDATE_DATA]({ state, getters, commit }) {
    let usersError = {};
    commit(SET_HINT, true); // 도움말 표시 On

    try {
      const attendantList = getters[ATTENDING_LIST];
      
      const infoAvailable = getters[INFO_AVAILABLE];

      const attendantFirst = attendantList[0].name;

      if(infoAvailable) {
        // 약관 존재 유무
        const existRequired = getters[REQUIRED_CONSENTS].length > 0;
        const existOptional = getters[OPTIONAL_CONSENTS].length > 0;
        // 설문 문항
        const infoQuestions = Object.keys(getters[INFO_QUESTIONS])
          .map(sq_code => getters[INFO_QUESTIONS][sq_code])
          .sort(questionComparator);

        // =========================================================
        // 사용자 정보 체크 START
        // =========================================================
        attendantList.forEach(attendant => {
          const person = attendant.name || '비사업배우자';

          usersError[person] = {"errorMessages": []}
          


          // 1. 비 사업자 이름 입력 체크
          if(!['E', 'P'].includes(attendant.type)) {
            if(!attendant.name) {
              const typeText = getFullTextByType(attendant);
              // throw new Error(getMessage('NAME_EMPTY', typeText));
              usersError[person].errorMessages.push(new Error(getMessage('NAME_EMPTY', typeText), {cause:'name'}));
              
            }
          }

          // 2. 참가자 정보 입력 사항 체크
          infoQuestions.forEach(question => {
            const { sq_code, required, type, res_type, title } = question;
            // console.log("참가자 정보 체크 : ", sq_code, required, type, res_type, title)
            if(required === 'TRUE') {
              // 문항 응답 타입이 있을때, 이에 포함되지 않으면 PASS
              if(res_type && !res_type.includes(attendant.type)) {
                return;
              }

              let error = false;
              if(type === 'F') {
                const { original_name, path, hasError } = attendant.questions[sq_code];
                if(!(original_name && path)) {
                  // throw new Error(getMessage('ATTACHMENT_EMPTY', person, title));
                  // usersError[person].errorMessages.push(new Error(getMessage('ATTACHMENT_EMPTY', person, title)));
                }

                hasError && (error = true);
              } else if(type === 'B') {
                const { raw_data, hasError } = attendant.questions[sq_code];
                if(!raw_data) {
                  // throw new Error(getMessage('RAWDATA_EMPTY', person, title));
                  // usersError[person].errorMessages.push(new Error(getMessage('RAWDATA_EMPTY', person, title)));
                }

                hasError && (error = true);
              }

              if(error) {
                // throw new Error(getMessage('HAS_ERROR', person, title));
                usersError[person].errorMessages.push(new Error(getMessage('HAS_ERROR', person, title), {cause:sq_code}));
              }
            }
          });

          // 3. 약관 동의 여부 체크
          const consents = attendant.consents;
          if(existRequired) {
            if(!consents.required) {
              // throw new Error(getMessage('CONSENT_EMPTY', person));
              usersError[person].errorMessages.push(new Error(getMessage('CONSENT_EMPTY', person), {cause:'consent-require'}));
            }
            
            if(consents.required !== 'Y') {
              // throw new Error(getMessage('CONSENT_NOT_AGREE', person));
              usersError[person].errorMessages.push(new Error(getMessage('CONSENT_NOT_AGREE', person), {cause:'consent-require'}));
            }
          }

          if(existOptional && !consents.optional) {
            // throw new Error(getMessage('CONSENT_OPTIONAL_EMPTY', person));
            usersError[person].errorMessages.push(new Error(getMessage('CONSENT_OPTIONAL_EMPTY', person), {cause:'consent-option'}));
          }

        });

        // 2. 공통 데이터 체크
        const commonData = state.commonData;
        const commonQuestions = getters[COMMON_QUESTIONS];
        Object.keys(commonData).forEach(key => {
            const { type, title, required } = commonQuestions[key];
            // console.log("공통 데이터 체크 : ", type, title, required, key)
            if(required === 'TRUE') {
              // 가족관계증명서가 필요하지 않은 경우에는 체크 안함
              if(key === 'Q104' && !getters[NEED_FAMILY_RELATION_DOCUMENT]) {
                return;
              }

              // 배우자참가신청서 필요하지 않은 경우에는 체크 안함
              if(key === 'Q103' && !getters[NEED_FAMILY_RELATION_DOCUMENT]) {
                return;
              }

              // 초상권확인 동의서
              if(key === 'Q102' && !getters[MEMBER_ATTENDANTS]) {
                // return false;
              }

              // 공통 데이터의 타입 별 validate
              if(type === 'F') {
                const { path, original_name } = commonData[key];
                if(!(path && original_name)) {
                  // throw new Error(getMessage('COMMON_DATA_EMPTY', title));
                  usersError[attendantFirst].errorMessages.push(new Error(getMessage('COMMON_DATA_EMPTY', title), {cause:key}));
                  // return false;
                }
              }
            }
          });
        // =========================================================
        // 사용자 정보 체크 END
        // =========================================================
      }

      const activityAvailable = getters[ACTIVITY_AVAILABLE];
      const mixQuestions = {...getters[ACTIVITY_QUESTIONS], ...getters[SCHEDULE_QUESTIONS]}; // 액티비티와 스케줄 정보를 함께 체크 
      
      if(activityAvailable) {
        // 액티비티
        const activities = Object.keys(mixQuestions)
          .map(sq_code => mixQuestions[sq_code])
          .sort(questionComparator);
        
        // =========================================================
        // 액티비티 체크 START
        // =========================================================
        const totalActivityCount = {};
        activities.forEach(activity => {
          const { sq_code, required, res_type, title, examples, area } = activity;
          if(required !== 'TRUE') {
            // 필수가 아니라면 PASS
            return;
          }

          if(res_type && !res_type.includes(attendant.type)) {
            // 응답을 하는 타입이 설정되어 있고, 해당 타입이 아니면 PASS
            return;
          }

          // 체크 시작
          attendantList.forEach(attendant => {
            const { name, type, type_seq, questions } = attendant;
            const choices = questions[sq_code];
            choices.forEach(choice => {
              const { se_code, se_data, remarks, checked } = choice;

              // vip 액티비티가 있는 경우 empty string으로 체크하면 "선택 안함"을 선택하는 것도 걸림
              // 선택이 되지 않은 null로 체크한다
              if(se_code === null) {
                const msg = getMessage(area == 'Q' ? 'ACTIVITY_EMPTY': 'SCHEDULE_EMPTY', name, title); // area 로 액티비티인지, 스케줄인지 메시지 분기처리 
                // throw new Error(`${msg}|${elId}-normal`);
                usersError[name].errorMessages.push(new Error(`${msg}`, {cause: sq_code}));
              } else if(se_code === '') {
                // 선택 안함
                return;
              }

              if(checked && !examples[se_code].pin || (examples[se_code] && examples[se_code].pin)) {
                if(!totalActivityCount[sq_code]) {
                  totalActivityCount[sq_code] = {};
                }
                const addCount = !examples[se_code].pin ? 1 : Number(se_data);
                totalActivityCount[sq_code][se_code] = (totalActivityCount[sq_code][se_code] || 0) + addCount;
              }
            });
          });
        });

        // submit 전 잔여 인원을 초과하여 선택하였는지 체크
        Object.keys(totalActivityCount).forEach(sq_code => {
          Object.keys(totalActivityCount[sq_code]).forEach(se_code => {
            const selectedQuestion = getters[ACTIVITY_QUESTIONS][sq_code];
            const selectedExample = selectedQuestion.examples[se_code];
            if(selectedExample.remain_num === null) return;
            let originalCount = 0;
            if(state.originals) {
              state.originals.forEach(original => {
                if(original.questions[sq_code]) {
                  const originalExample = original.questions[sq_code].find(choice => choice.se_code === se_code);
                  if(originalExample) {
                    originalCount += originalExample.se_data ? Number(originalExample.se_data) : 1;
                  }
                }
              });
            }
            const remainNum = selectedExample.remain_num + originalCount;
            if(totalActivityCount[sq_code][se_code] > remainNum) {
              const msg = getMessage('ACTIVITY_LIMIT_EXCEED', selectedQuestion.title, selectedExample.display_text);
              // throw new Error(`${msg}|${sq_code}-top`);
              usersError[person].errorMessages.push(new Error(getMessage(`${msg}|${sq_code}-top`), {cause: sq_code}));
            }
          });
        });

        // =========================================================
        // 액티비티 체크 END
        // =========================================================
      }
      
      // 정상
      // return null;
      return usersError;
    } catch (error) {
      // 에러 메시지 반환
      // return error.message;
      console.log("Validation Error : ", error)
      return usersError;
    }
  },
  /**
   * SUBMIT SURVEY
   * 1. 설문 응답 제출/수정
   * 2. 정상 제출/수정 완료 시 삭제한 첨부파일 데이터 S3에서 삭제
   * 
   * ============================================================
   * ** 최초 작성 시
   * - 불참 선택한 동반 가족 필터링
   * - 응답 데이터 가공 후 regist
   * 
   * ** 수정 시
   * [참석 선택한 경우]
   * 1. 기존에 참석 선택
   * - original 데이터와 비교하여 변경된 데이터만 필터링 후 update
   * 2. 불참 -> 참석 변경(응답 데이터가 있음)
   * - 데이터 가공 추출 후 update
   * 3. 기존에 없었던 추가 응답자
   * - 최초 작성 시와 동일
   * 
   * [불참 선택한 경우]
   * 1. 최초 불참 응답(동반가족인 경우)
   * - X
   * 2. 기존에 불참 응답
   * - X
   * 3. 참석 -> 불참 변경
   * - 액티비티 잔여 인원 롤백을 original 데이터 전달
   * ============================================================
   */
  async [SUBMIT_SURVEY]({ state, getters, commit, dispatch }) {
    commit(SET_LOADING, true);
    const isFirstSubmit = state.mode === 'W';

    // =============================================================================
    // 1. submit data extract
    // =============================================================================
    // payload = { responses(응답데이터), commons(공통응답데이터) }
    const { responses, commons } = await dispatch(isFirstSubmit ? FIRST_SUBMIT : SAVE_SUBMIT);
    // =============================================================================
    // 2. submit
    // =============================================================================
    const requestUrl = `${process.env.AWS_GATEWAY_URL_V2}/survey`;
    const { data } = await axios.post(`${requestUrl}/${isFirstSubmit ? 'regist' : 'update'}`, {
      responses,
      commons,
      pinLevel: state.pin_level,
      toBeDeleted: state.responsesForDelete,
      infoAvailable: getters[INFO_AVAILABLE],
      activityAvailable: getters[ACTIVITY_AVAILABLE]
    });

    // =============================================================================
    // 3. handle response after submit
    // =============================================================================
    if(data.status !== 200 && data.status !== 201) { // 정상 응답이 아닌 경우
      switch(data.message) {
        case 'SURVEY_NOT_FOUND': // 없는 설문
        case 'SURVEY_NOT_OPENED': // 오픈되지 않은 설문
        case 'SURVEY_ALREADY_CLOSED': // 종료된 설문
          alert(getErrorMsg(data.status, data.message));
          window.location.href = process.env.AMWAY_ROOT_URL;
          return false;

        case 'ACTIVITY_NO_REMAINING': // 액티비티 잔여 인원 부족
          const { list } = data;
          // 부족한 액티비티 별 alert message 추가
          const alertMsg = list.map(activity => {
            const { sq_code, value: name } = activity;
            const title = getters[ACTIVITY_QUESTIONS][sq_code].title;
            return getMessage('ALERT_ACTIVITY_NO_REMAINING', title, name);
          }).join('\n');
          await dispatch(UPDATE_ACTIVITY_REMAIN_NUM, list);
          throw new Error(alertMsg);

        default:
          throw new Error(getErrorMsg(data.status, data.message));
      }
    }

    // =============================================================================
    // 4. delete files from S3
    // =============================================================================
    // 지웠던 첨부파일 S3 Bucket에서 삭제
    const files = state.filesForDelete;
    if(files.length > 0) {
      try {
        const { Errors: errors } = await deleteFilesFromS3(files);
        errors.length > 0 && console.log(errors);
      } catch (error) {
        console.error('Delete Attachment ERROR!!', error.stack);
      }
    }

    return true;
  },
  /**
   * 최초 설문 제출 로직
   */
  [FIRST_SUBMIT]({ state, getters }) {
    const responses = state.responses.map(response => {
      // 1. 동반 가족이 불참인 경우는 제출X
      if(response.type === 'F' && (!response.attendance_yn || response.attendance_yn === 'N')) {
        return null;
      }

      // 2. response 별 약관 데이터, 응답 문항 데이터 가공 추출
      const { abo_uid, name, attendance_yn, s_code, wave_number, type, type_seq } = response;
      const [consents, datas] = getters[GET_RESPONSE_DATA](response);

      // 3. 동반가족의 경우 결제 정보 데이터 추가
      const paymentInfo = response.type === 'F' && getters[IS_FAMILY_NEED_PAYMENT](response.type_seq) ? response.paymentInfo : null;

      return {
        abo_uid,
        name,
        attendance_yn,
        s_code,
        wave_number,
        type,
        type_seq,
        consents,
        datas,
        paymentInfo
      };
    }).filter(response => response !== null);

    // 3. common data 추출
    const commons = Object.keys(state.commonData)
      .map(sq_code => {
        const data = state.commonData[sq_code];
        // common data 타입별 처리
        if(data.reference.startsWith("file")) {
          return data.original_name && data.path ? data : null;
        }
        // 나머지는 모두 패스
        return null;
      })
      .filter(commonData => !!commonData);
    
    return { responses, commons };
  },
  /**
   * 설문 수정
   */
  async [SAVE_SUBMIT]({ state, getters, commit, dispatch }) {
    const getOriginalIndexFunc = getters[GET_ORIGINAL_IDX_BY_SEQ];
    const infoAvailable = getters[INFO_AVAILABLE];
    const activityAvailable = getters[ACTIVITY_AVAILABLE];

    let responses, commons, activities = null;

    if(infoAvailable) {// 사용자 정보 수정 가능 시
      // response 별 약관 데이터, 사용자 정보 문항 데이터
      responses = state.responses.map(response => {
        const { sr_seq, abo_uid, name, attendance_yn, s_code, wave_number, type, type_seq } = response;
        const originalIdx = getOriginalIndexFunc(sr_seq);
  
        // ==============================================
        // ================== 참석 응답 ==================
        // ==============================================
        if(attendance_yn === 'Y') {
          //   약관   /   문항
          let [consents, datas] = getters[GET_RESPONSE_DATA](response);
          let originals = null; // 이전 응답

          if(originalIdx > -1) { // 기존 응답자
            originals = state.originals[originalIdx];
            if(originals.attendance_yn === 'Y') { // 기존 참석 응답자
              // 기존 참석 응답자만
              // 데이터 비교를 통해 변경된 데이터(약관-consents, 문항-datas) 필터링
              // 예외로 결제 정보(paymentInfo)는 비교하지않고 조건에 따라 제출(람다에서 비교)
              const { consents: originConsents, questions: originDatas } = originals;
  
              // 변경된 약관 데이터
              consents = consents.filter(consent => originConsents[consent.c_code].agree_yn !== consent.agree_yn);
  
              // 변경된 응답 문항 데이터
              const infoQuestions = getters[INFO_QUESTIONS];

              const infoDatas = datas
                // 사용자 정보 문항만 필터링
                .filter(data => Object.keys(infoQuestions).includes(data.sq_code))
                // 새로운 문항 응답 혹은 변경된 문항만 필터링
                .filter(data => {
                  const sqCode = data.sq_code;
                  
                  // 기존에 응답하지 않았던 새로운 문항이면 추가
                  if(!originDatas[sqCode]) return true;

                  const { type } = infoQuestions[sqCode];
                  switch (type) {
                    case 'B': // 주관식 문항
                      const raw_data = data.raw_data;
                      return raw_data !== undefined && raw_data !== null && raw_data !== originDatas[sqCode].raw_data;
                    case 'F': // 첨부파일 문항
                      const { path, original_name } = data;
                      return path && original_name && (path !== originDatas[sqCode].path || original_name !== originDatas[sqCode].original_name);
                    default:
                      return false;
                  }
                  
                });
              
              datas = [...infoDatas];
            }
          }
  
          const paymentInfo = type === 'F' && getters[IS_FAMILY_NEED_PAYMENT](type_seq) ? response.paymentInfo : null;
          return {
            sr_seq, // 기존에 없었던 추가 응답자(동반가족) 제외 데이터 있음
            abo_uid, // 기존에 없었던 추가 응답자(동반가족)
            name,
            attendance_yn,
            s_code,
            wave_number,
            type,
            type_seq,
            consents, // 기존 참석 응답자만 변경된 데이터
            datas, // 기존 참석 응답자만 변경된 데이터
            paymentInfo, // 동반가족의 경우 결제 정보 데이터 추가
            originals // 기존 응답자만
          };
        } else {
          // ==============================================
          // ================== 불참 응답 ==================
          // ==============================================
          if(originalIdx > -1) { // 기존 응답자
            const originals = state.originals[originalIdx];
            if(originals.attendance_yn === 'Y') {
              // 개인별 자료 삭제 
              const deleteFiles = `${originals.questions['Q100'].path}/${originals.questions['Q100'].original_name}`;
              commit(SET_FILES_FOR_DELETE, deleteFiles)

              // 참석 응답에서 불참으로 변경
              if(type !== 'F') {
                // 사업자가 불참 선택 시 참여 여부 Y -> N으로 변경
                return {
                  sr_seq,
                  abo_uid,
                  name: type === 'E' || type === 'P' ? name : null,
                  attendance_yn,
                  s_code,
                  wave_number,
                  type,
                  type_seq,
                  originals
                };
              } else {
                // 동반가족이 불참 선택 시 해당 응답 데이터 삭제
                commit(SET_RESPONSES_FOR_DELETE, sr_seq);
                return null;
              }
            } else {
              // 기존 불참 응답자(사업자)
              return null;
            }
          } else { // 기존 미 응답자(동반 가족)
            return null;
          }
        }
      }).filter(response => !!response);

      // console.log(" 설문 정보 완료 !! ")
  
      // 공통 데이터 추출 전 삭제 필요한 경우 전처리
      if(!getters[EXIST_ATTENDANT]) { // 참석자가 없다면 공통 데이터 모두 삭제
        const promises = Object.keys(state.commonData).map(sq_code => dispatch(CLEAR_COMMON_DATA, sq_code));
        await Promise.all(promises);
      } else {
        if(!getters[NEED_FAMILY_RELATION_DOCUMENT]) {
          // 가족관계증명서가 필요 없는데, 기존에 가족관계증명서를 제출했다면 해당 데이터 삭제
          await dispatch(CLEAR_COMMON_DATA, 'Q104');
        }
        if(!getters[NEED_FAMILY_DOCUMENT]) {
          // 객실 추가 신청서가 필요 없는데, 기존에 객실 추가 신청서를 제출했다면 해당 데이터 삭제
          // await dispatch(CLEAR_COMMON_DATA, 'Q027');
        }
      }

      // console.log(" 공통 데이터 정보 완료 !! ")
  
      // 공통 데이터 추출
      const commonQuestions = getters[COMMON_QUESTIONS];
      const originalCommonData = state.originalCommonData;
      commons = Object.keys(state.commonData)
        .map(sq_code => {
          const { required } = commonQuestions[sq_code];
  
          const commonData = state.commonData[sq_code];
          const originalData = originalCommonData[sq_code];
          // 파일 common Data
          if(commonData.reference.startsWith("file")) {
            const { original_name, path } = commonData;
  
            if(original_name && path) {
              // 현재 응답 데이터가 있을 때
              if(!originalData || (commonData.original_name !== originalData.original_name || commonData.path !== originalData.path)) {
                // 기존 데이터가 없거나 기존 데이터와 다를 경우에만 추가
                return commonData;
              }
            } else {
              // 현재 응답 데이터가 없을 때
              // 선택 응답만  기존 데이터가 있고 기존 데이터와 다르면 추가
              // 예외로 필수 응답이지만 Q012(가족관계증명서)는 필요 없어진 경우 데이터 삭제를 위해 추가될 수 있음
              if(required === 'FALSE' || sq_code === 'Q104') {
                if(originalData && (original_name !== originalData.original_name || path !== originalData.path)) {
                  return commonData;
                }
              }
            }
          }
          // 나머지는 모두 패스
          return null;
        }).filter(commonData => !!commonData);
        // console.log(" 파일처리 정보 완료 !! ")
    } 

    if(activityAvailable) {// 액티비티만 수정 가능 시
      // 액티비티만 수정하는 경우 사용자 정보의 변경사항이 없으므로 참석자를 기준으로만 한다.
      activities = getters[ATTENDING_LIST].map(response => {
        const { sr_seq, abo_uid, name, attendance_yn, s_code, wave_number, type, type_seq } = response;
        let datas = getters[GET_RESPONSE_DATA](response)[1];
        const originals = state.originals[getOriginalIndexFunc(sr_seq)];

        // Activity 와 Schduel 변경사항에 대해 변경된 내용을 체크 한다. 
        const activityQuestionCode = ["Q124","Q125","Q126"];
        const scheduleQuestionCode = [];

        datas = datas
          .filter(data => activityQuestionCode.concat(scheduleQuestionCode).includes(data.sq_code)) // 
          .filter(data => {
          const { sq_code, se_code, se_data, remarks } = data;
          const originData = originals.questions[sq_code];
          // 액티비티 문항에 대한 응답 자체가 없다면 true반환(액티비티 신규 응답이므로)
          if(!originData) return true;

          const sq_codes = getters[ACTIVITY_QUESTIONS][sq_code] || getters[SCHEDULE_QUESTIONS][sq_code]; // Activity 와 Schedule 을 모두 체크 
          
          const examplesMetadata = sq_codes.examples;
          // 일반 액티비티 여부
          const isNormalActivity = se_code === '' || !examplesMetadata[se_code].pin;
          const originalResponse = originData.find(origin => origin.se_code === se_code);

          // 일반 액티비티는 기존 응답 데이터에 현재 선택한 액티비티 코드가 없으면 추가
          if(isNormalActivity) return !originalResponse;

        });

        return {
          sr_seq,
          abo_uid,
          name,
          attendance_yn,
          s_code,
          wave_number,
          type,
          type_seq,
          consents: [], // 약관 데이터X
          datas,
          paymentInfo: null, // 결제 정보 데이터X
          originals
        };
      });

      // 변경할 공통 데이터 없음 : Activity 만 신청을 받지 않아서 common 데이터가 존재 할 수 있음 
      // commons = [];
    }

    // 설문응답과 액티비티를 동시에 받다 보니 responses 에 activity 가 포함되어 있어 제거해준다.
    responses.filter(response => response.datas)
      .filter(response => {
      // const dupDatas = [...new Map(response.datas.map((data) => [data.sq_code, data])).values()];
      const dupDatas = response.datas.filter(data => !data.se_code);
      response.datas = dupDatas;
    })

    // 설문응답에 Activity 응답을 합침
    if(activityAvailable) {
      responses.forEach(infomation => {
        activities.forEach(activity => {
          if( infomation.type_seq == activity.type_seq && infomation.sr_seq == activity.sr_seq) { // 응답값이 같은 경우만 처리 
            infomation.datas = infomation.datas.concat(activity.datas)
          }
        });
      });
    }

    return { responses, commons };
  },
  [CLEAR_COMMON_DATA]({ state, commit }, sq_code) {
    const { path, original_name } = state.commonData[sq_code];
    if(path && original_name) {
      commit(SET_FILES_FOR_DELETE, `${path}/${original_name}`);
      commit(SET_COMMON_DATA, { sq_code, original_name: null, path: null, hasError: false });
    }
  },
  [UPDATE_ACTIVITY_REMAIN_NUM]({ commit, state, getters }, list) {
    const activityQuestions = getters[ACTIVITY_QUESTIONS];
    list.forEach(activity => {
      const { sq_code, se_code, remain_num } = activity;

      // 해당 액티비티를 선택한 선택지를 데이터 찾아 변경
      state.responses.forEach((response, idx) => {
        const choices = response.questions[sq_code];
        const updatedChoices = choices.map(choice => {
          // 선택한 액티비티만 업데이트
          if(choice.se_code === se_code) {
            const isRunOut = remain_num === 0; // 잔여 인원 0 여부
            // 기존 응답값 조회
            const originalIdx = getters[GET_ORIGINAL_IDX_BY_SEQ](response.sr_seq);
            const hasOriginalChoices = originalIdx > -1 && state.originals[originalIdx] && state.originals[originalIdx].questions[sq_code];
          }

          // 모두 해당하지 않는다면 동일하게
          return { ...choice };
        });
        commit(SET_CHOICE_QUESTION, { idx, sq_code, choices: updatedChoices });
      });
      // 잔여 인원이 부족한 선택지 업데이트 후 잔여 인원도 업데이트
      commit(SET_ACTIVITY_REMAIN_NUM, { sq_code, se_code, remain_num });
    });
  },
  [ADD_NEW_FAMILY]({ commit, state, getters }, attendance_yn) {
    commit(SET_RESPONSE_DATAS, [...state.responses, getters[GET_NEW_FAMILY](attendance_yn)]);
  },
  [REMOVE_FAMILY]({ state, getters, commit }, index) {
    // >>> responses 배열에서 삭제하고, 실 파일 데이터 삭제
    const copyResponses = [...state.responses];
    const [deletedFamily] = copyResponses.splice(index, 1);
    Object.keys(deletedFamily.questions).forEach(sq_code => {
      const { path, original_name } = deletedFamily.questions[sq_code];
      if(path && original_name) {
        commit(SET_FILES_FOR_DELETE, `${path}/${original_name}`);
      }
    });

    commit(SET_RESPONSE_DATAS, copyResponses);

    // DB에 저장되어 있는 동반가족이면 추가로 sr_seq값을 제출하여 삭제
    const { sr_seq } = deletedFamily;
    const originalIdx = getters[GET_ORIGINAL_IDX_BY_SEQ](sr_seq);
    if(originalIdx > -1) {
      commit(SET_RESPONSES_FOR_DELETE, sr_seq);
    }
  },
  /**
   * 일반 액티비티 선택
   */
  [SELECT_CHOICE_DATA]({ state, getters, commit }, { idx, ...payload }) {
    const sq_code = payload.sq_code; // 선택하는 example의 문항 코드
    const choices = [...state.responses[idx].questions[sq_code]]; // 현재 response의 해당 문항 응답 배열
    const activityExamples = getters[ACTIVITY_QUESTIONS][sq_code].examples;
    // 일반 액티비티 리스트
    const normalExamples = Object.keys(activityExamples).filter(se_code => !activityExamples[se_code].pin);

    // 현재 문항 응답 배열에서 일반 액티비티 응답 인덱스 조회
    const choiceIndex = choices.findIndex(choice => !choice.se_code || normalExamples.includes(choice.se_code));
    // 해당 인덱스 값에 현재 선택한 액티비티 값 반영
    choices[choiceIndex] = { ...choices[choiceIndex], ...payload };

    commit(SET_CHOICE_QUESTION, { idx, sq_code, choices });
  },
  /**
   * 일반 액티비티 선택
   */
  [SELECT_SCHEDULE_DATA]({ state, getters, commit }, { idx, ...payload }) {
    const sq_code = payload.sq_code; // 선택하는 example의 문항 코드
    const choices = [...state.responses[idx].questions[sq_code]]; // 현재 response의 해당 문항 응답 배열
    const schduleExamples = getters[SCHEDULE_QUESTIONS][sq_code].examples;
    // 일반 액티비티 리스트
    const normalExamples = Object.keys(schduleExamples).filter(se_code => !schduleExamples[se_code].pin);

    // 현재 문항 응답 배열에서 일반 액티비티 응답 인덱스 조회
    const choiceIndex = choices.findIndex(choice => !choice.se_code || normalExamples.includes(choice.se_code));
    // 해당 인덱스 값에 현재 선택한 액티비티 값 반영
    choices[choiceIndex] = { ...choices[choiceIndex], ...payload };

    commit(SET_CHOICE_QUESTION, { idx, sq_code, choices });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}